import { render, staticRenderFns } from "./ProductsSubTotalList.vue?vue&type=template&id=0cb6c956&scoped=true&"
import script from "./ProductsSubTotalList.vue?vue&type=script&lang=js&"
export * from "./ProductsSubTotalList.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSubTotalList.vue?vue&type=style&index=0&id=0cb6c956&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb6c956",
  null
  
)

export default component.exports